export function getCourseNameFromEnum(enumString) {
    if (!enumString.startsWith("COURSE_TYPE")) return null;
    
    // Remove the prefix and format properly
    return enumString
      .replace("COURSE_TYPE", "") // Remove prefix
      .replace(/_/g, " ") // Replace underscores with spaces
      .toLowerCase() // Convert to lowercase
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
  }

  export function getLearningModeFromEnum(enumString) {
    if(!enumString){
      return "Offline"
    }
    if (!enumString.startsWith("LEARNING_MODE")) return null;
    
    // Remove the prefix and format properly
    return enumString
      .replace("LEARNING_MODE", "") // Remove prefix
      .replace(/_/g, " ") // Replace underscores with spaces
      .toLowerCase() // Convert to lowercase
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
  }